"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _UnreachableCaseError = require("@oberoninternal/travelbase-ds/entities/UnreachableCaseError");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
const _excluded = ["children", "href", "onClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const SearchDateHitCount = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
      children,
      href,
      onClick
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    hits,
    active
  } = props;
  const isDisabled = hits === 0;
  const commonProps = {
    disabled: isDisabled,
    href: !isDisabled ? href : undefined,
    onClick: !isDisabled ? onClick : undefined,
    active: !!active
  };
  switch (props.variant) {
    case 'desktop':
      {
        const {
          mostHits,
          index,
          animate
        } = props;
        return __jsx(Desktop, {
          mostHits: mostHits,
          className: "gt-s"
        }, __jsx(Filler, (0, _extends2.default)({
          ref: ref,
          hits: hits,
          animate: animate,
          index: index,
          mostHits: mostHits
        }, commonProps), __jsx(CountWrapper, null, __jsx(Count, null, hits))));
      }
    case 'mobile':
      {
        if (isDisabled) {
          return null;
        }
        return __jsx(Mobile, (0, _extends2.default)({
          ref: ref,
          className: "lt-s"
        }, commonProps), children, __jsx(Count, {
          style: {
            marginLeft: 'auto'
          }
        }, hits));
      }
    default:
      throw new _UnreachableCaseError.UnreachableCaseError(props);
  }
});
var _default = exports.default = SearchDateHitCount;
const CountWrapper = _styledComponents.default.div.withConfig({
  displayName: "SearchDateHitCount__CountWrapper",
  componentId: "h6wjrw-0"
})(["width:100%;position:absolute;left:0;top:-1.4rem;display:flex;justify-content:center;"]);
const Count = _styledComponents.default.div.withConfig({
  displayName: "SearchDateHitCount__Count",
  componentId: "h6wjrw-1"
})(["background:", ";border-radius:1.5rem;min-width:4rem;color:", ";font-weight:500;display:flex;justify-content:center;font-size:14px;height:2.8rem;align-items:center;"], ({
  theme
}) => theme.colors.secondary['30'], ({
  theme
}) => theme.colors.neutral['0']);
const computeHeight = val => `calc(1.6rem + ${val} * 20rem)`;
const Desktop = _styledComponents.default.div.withConfig({
  displayName: "SearchDateHitCount__Desktop",
  componentId: "h6wjrw-2"
})(["position:relative;max-height:21.6rem;--totalHeight:20rem;height:", ";"], computeHeight(1));
const Mobile = _styledComponents.default.a.withConfig({
  displayName: "SearchDateHitCount__Mobile",
  componentId: "h6wjrw-3"
})(["text-decoration:none !important;height:5.6rem;background:", ";border:1px solid ", ";border-radius:8px;display:flex;padding:0 ", ";align-items:center;", ";"], ({
  theme
}) => theme.colors.neutral['5'], ({
  theme
}) => theme.colors.neutral['20'], ({
  theme
}) => theme.spacing['40_Standard'], ({
  active
}) => active && (0, _styledComponents.css)(["background:", ";p{color:white !important;}", "{background:white;color:", ";}"], ({
  theme
}) => theme.colors.secondary['30'], Count, ({
  theme
}) => theme.colors.secondary['30']));
const Filler = _styledComponents.default.a.withConfig({
  displayName: "SearchDateHitCount__Filler",
  componentId: "h6wjrw-4"
})(["position:absolute;bottom:-1px;left:0;background:", ";--border-color:", ";border-radius:5px 5px 0 0;width:100%;height:", ";box-shadow:inset 0 0 0 1px var(--border-color);transition:all 100ms ease-in-out;:hover{--border-color:", ";box-shadow:inset 0 0 0 2px var(--border-color);", "{transform:scale(1.1);transition:all 200ms ease-in-out;}}transform:translateY(calc(100% - 1.6rem));animation:", " 1s forwards ease-in-out;animation-delay:", ";@keyframes fadein{from{transform:translateY(calc(100% - 1.6rem));}to{transform:translateY(0);}}", ";"], ({
  active,
  theme
}) => theme.colors.secondary[active ? '30' : '10'], ({
  theme,
  active
}) => active ? 'transparant' : theme.colors.secondary['20'], ({
  hits,
  mostHits
}) => computeHeight(hits / mostHits), ({
  theme
}) => theme.colors.secondary['30'], Count, ({
  animate
}) => animate && 'fadein', ({
  index
}) => `${index / 15}s`, ({
  disabled,
  theme,
  active
}) => disabled && (0, _styledComponents.css)(["background:", ";--border-color:", ";:hover{--border-color:", ";}", "{background:", ";}"], theme.colors.neutral[active ? '30' : '20'], active ? 'transparant' : theme.colors.neutral['20'], active ? 'transparant' : theme.colors.neutral['30'], Count, theme.colors.neutral['30']));